"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RESPONSIVE_LAYER = void 0;
var RESPONSIVE_LAYER = exports.RESPONSIVE_LAYER = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400
};